import { useMutation, MutationHookOptions } from '@apollo/client';

import { CHECK_IN_SEND_WORK_ITEMS } from '@affiliates/queries';
import { CheckInSendWorkItems, CheckInSendWorkItemsVariables } from '@affiliates/queries/types/CheckInSendWorkItems';

type TOptions = MutationHookOptions<CheckInSendWorkItems, CheckInSendWorkItemsVariables>;

export const useCheckInSendWorkItems = (options: TOptions = {}) => useMutation<CheckInSendWorkItems, CheckInSendWorkItemsVariables>(CHECK_IN_SEND_WORK_ITEMS, options);
